import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Megaphone } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";

const API = process.env.REACT_APP_BACKEND_URL;
const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const AnnouncementAdmin = () => {
  const [form, setForm] = useState({ enabled: false, message: "", link: "", start_date: "", end_date: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetch(`${API}/api/admin/announcement`, { headers: authHeaders() })
      .then((r) => r.json())
      .then((d) => setForm({ enabled: !!d.enabled, message: d.message || "", link: d.link || "", start_date: d.start_date || "", end_date: d.end_date || "" }))
      .catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const res = await fetch(`${API}/api/admin/announcement`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", ...authHeaders() },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error();
      toast.success("Bandeau enregistré");
    } catch {
      toast.error("Enregistrement impossible");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6 max-w-2xl" data-testid="announcement-admin">
      <div>
        <h2 className="text-xl font-medium text-[#1F2A4A] flex items-center gap-2"><Megaphone className="w-5 h-5 text-[#C9B896]" /> Bandeau d'annonce</h2>
        <p className="text-sm text-[#1F2A4A]/60">Message défilant affiché tout en haut du site. Contrôlez le texte et la période de diffusion.</p>
      </div>

      <div className="bg-white border border-[#1F2A4A]/10 rounded-2xl p-6 space-y-5">
        <div className="flex items-center justify-between">
          <div>
            <Label className="text-[#1F2A4A] font-medium">Diffusion active</Label>
            <p className="text-xs text-[#1F2A4A]/60">Le bandeau n'apparaît que si activé et dans la période choisie.</p>
          </div>
          <Switch checked={form.enabled} onCheckedChange={(v) => setForm({ ...form, enabled: v })} data-testid="announcement-enabled-switch" />
        </div>
        <div>
          <Label className="text-[#1F2A4A] mb-1.5 block">Message (max 300 caractères)</Label>
          <Input value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Ex : Nouvelle formation Recovering & Garnissage Multisupports — sessions 2027 ouvertes !" data-testid="announcement-message-input" />
        </div>
        <div>
          <Label className="text-[#1F2A4A] mb-1.5 block">Lien au clic (optionnel)</Label>
          <Input value={form.link} onChange={(e) => setForm({ ...form, link: e.target.value })} placeholder="/fr/formations-sur-place" data-testid="announcement-link-input" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label className="text-[#1F2A4A] mb-1.5 block">Début de diffusion</Label>
            <Input type="date" value={form.start_date} onChange={(e) => setForm({ ...form, start_date: e.target.value })} data-testid="announcement-start-input" />
          </div>
          <div>
            <Label className="text-[#1F2A4A] mb-1.5 block">Fin de diffusion</Label>
            <Input type="date" value={form.end_date} onChange={(e) => setForm({ ...form, end_date: e.target.value })} data-testid="announcement-end-input" />
          </div>
        </div>
        <p className="text-xs text-[#1F2A4A]/50">Laissez les dates vides pour une diffusion permanente tant que le bandeau est actif.</p>
        <Button onClick={save} disabled={saving} className="bg-[#1F2A4A] text-white hover:bg-[#324166]" data-testid="announcement-save-btn">
          {saving ? "Enregistrement…" : "Enregistrer"}
        </Button>
      </div>
    </div>
  );
};
